// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2VS6t","footer":"ChangeClinic_footer__2Rlr5"};